export const WORKER_IDS = {
  UPLOAD_DATA: 'uploadData',
  CONFUSION_MATRIX: 'confusionMatrix',
};
